import { withStylePrefix } from '../common/withStylePrefix';
import { BannerComponent, bannerTemplate } from './Banner';
import styles from './Banner.styles.scss';
export const bannerDefinition = {
    baseName: 'banner',
    template: bannerTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonBanner = BannerComponent.compose(bannerDefinition);
